export default __webpack_public_path__ + "images/about/2 Евгения Каплина дизайнер, главный проектировщик.jpg";